import * as S from "./SearchBox.style";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { InputText } from "@/components/atoms/Inputs/InputText";
import { ReactComponent as IconSearch } from "@/styles/assets/svg/icon_search.svg";

interface SearchBoxProps {
  size?: "md" | "lg";
  label?: string;
  handleClick: (inputValue: string) => void;
}

export const SearchBox = ({
  size = "md",
  label,
  handleClick,
}: SearchBoxProps) => {
  const [inputValue, setInputValue] = useState("");

  const handleTextChange = (e: any) => {
    setInputValue(e.target.value);
  };

  const onClick = () => {
    handleClick(inputValue);
  };

  return (
    <S.Search>
      {label && <S.SearchLabel>{label}</S.SearchLabel>}

      <S.SearchInput $size={size}>
        <InputText size={size} onChange={handleTextChange} />
        <Buttons
          type="button"
          size="lg"
          color="primary100"
          layout="text"
          onClick={onClick}
          icon={<IconSearch width={30} height={30} />}
        />
      </S.SearchInput>
    </S.Search>
  );
};
